module.exports = __webpack_public_path__ + "img/question_feedback_disable_icon.55f9116d.svg";